<template>
  <a-layout-header class="header">
    <div class="wrapper">
      <div>
        <h1 v-html="title" />
      </div>
      <a-button
        v-if="addButton"
        @click="changeRoute(addButton.route)"
        type="primary"
        icon="plus"
        size="large"
        >{{ addButton.label }}
      </a-button>
    </div>
  </a-layout-header>
</template>

<script>
export default {
  props: {
    avatar: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    addButton: {
      type: Object,
      required: false
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  height: 116px;
  line-height: 64px;
  padding: 0;
  margin-bottom: -8px;
  margin-top: 8px;
}

.wrapper {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.avatar {
  margin-right: 12px;
}
</style>
